import React, { useState } from 'react';
import styles from './sync.module.scss';
import {
  KoButton,
  KoDescription,
  KoForm,
  KoFormBuilder,
  KoLoader,
  KoModal,
  KoText,
  KoTitle,
  KoToast
} from 'packages';
import KoIcon from '@kwapio/icons';
import { workspaceAPI } from '../workspace.service';

export default function SyncTask({ workspace }) {

  const [isOpen, setModal] = useState(false);
  const [form] = KoForm.useForm();
  const [appSettings, setAppSettings] = useState({});
  const [isLoading, setLoading] = useState(false);
  const workspaceId = workspace?.workspaceId;

  console.log("Workspace ID from parent:", workspaceId);

  const APPS = [
    {
      name: 'Jira',
      icon: 'Jiralogo',
      key: 'jira',
      description: 'Sync your Jira Tickets',
      fields: [
        { key: 'accessToken', label: 'Access Token', colSpan: 2, rules: [{ required: true }] },
        { key: 'baseUrl', label: 'Base Url', colSpan: 2, rules: [{ required: true }] },
        { key: 'email', label: 'Email', colSpan: 2, rules: [{ required: true }] },
        { key: 'projectKey', label: 'Project Key', colSpan: 2, rules: [{ required: true }] }
      ]
    },
    {
      name: 'Asana',
      icon: 'Asanalogo',
      key: 'asana',
      description: 'Sync Your Asana Tickets',
      fields: [
        { key: 'access_token', label: 'Access Token', colSpan: 2, rules: [{ required: true }] },
        { key: 'project_id', label: 'Project ID', colSpan: 2, rules: [{ required: true }] }
      ]
    },
    {
      name: 'Avaza',
      icon: 'Asanalogo',
      key: 'avaza',
      description: 'Sync Your Avaza Tickets',
      fields: [
        { key: 'accessToken', label: 'Access Token', colSpan: 2, rules: [{ required: true }] },
        { key: 'baseUrl', label: 'Base Url', colSpan: 2, rules: [{ required: true }] },
        { key: 'projectId', label: 'Project ID', colSpan: 2, rules: [{ required: true }] }
      ]
    }
  ];

  const handleCreationTickets = (app) => {
    setAppSettings(app);
    form.resetFields();
    setModal(true);
  };

  const handleSubmit = async(values) => {
    setLoading(true);

    try {
      if (appSettings.key === "avaza") {
        values.projectId = Number(values.projectId);
      }

      let res;

      if (appSettings.key === "jira") {
        res = await workspaceAPI.createJiraTickets(workspaceId, values);
      }
      if (appSettings.key === "asana") {
        res = await workspaceAPI.createAsanaTickets(workspaceId, values);
      }
      if (appSettings.key === "avaza") {
        res = await workspaceAPI.createAvazaTickets(workspaceId, values);
        console.log("Sync Response:", res);

      }

      KoToast.success("Synced successfully!");
      setModal(false);
      form.resetFields();

    } catch (err) {
      console.error(err);
      KoToast.error(err?.message || "Sync failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>

      <KoTitle text={'App Integrations'} level={4} />
      <KoText text={'Connect with Zoom, Microsoft Teams, Google Meet, and more.'} className={styles.text} />

      <div className={styles.content}>
        <div className={styles.meetingApps}>
          {APPS.map((app, index) => (
            <div className={styles.app} key={index}>
              <div className={styles.appWrapper}>
                <KoIcon name={app.icon} width={45} height={45} />
                <div className={styles.appTextWrapper}>
                  <KoText text={app.name} className={styles.appText} />
                  <KoDescription text={app.description} className={styles.desc} />
                </div>
              </div>

              <div className={styles.footer}>
                <KoButton
                  onClick={() => handleCreationTickets(app)}
                  text={'Connect'}
                  type={'primary'}
                  size={'small'}
                  className={styles.appBtn}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <KoModal
        title={appSettings.name}
        open={isOpen}
        centered
        width={700}
        onClose={() => setModal(false)}
        footer={[
          <KoButton key='cancel' label='Close' onClick={() => setModal(false)} />,
          <KoButton key='submit' label='Sync' type='primary' onClick={() => form.submit()} />
        ]}
      >
        <div className={styles.formWrapper}>
          {isLoading && <KoLoader />}

          <KoForm form={form} layout="vertical" onFinish={handleSubmit}>
            <KoFormBuilder
              form={form}
              meta={{
                columns: 4,
                initialValues: {},
                fields: appSettings.fields
              }}
            />
          </KoForm>
        </div>
      </KoModal>

    </div>
  );
}
